<template>
  <div>
    <article>
      <form @submit.prevent="login">
        <div class="field">
          <label for="email">Email</label>
          <input
            class="input"
            type="text"
            name="email"
            v-model="username"
            required
          />
        </div>
        <div class="field">
          <label for="password">{{ $t("navigation.password") }}</label>
          <input
            class="input"
            type="password"
            name="password"
            v-model="password"
            required
          />
        </div>
        <div class="field">
          <input class="button" type="submit" :value="loginText" />
        </div>
        <div v-if="error" class="error">{{ error }}</div>
      </form>
    </article>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "login",
  data() {
    return {
      username: "",
      password: "",
      error: "",
      loginText: this.$t("navigation.login"),
    };
  },
  methods: {
    async login() {
      try {
        this.error = "";
        let response = await axios.post(
          process.env.VUE_APP_API_URL_EN + "wp-json/jwt-auth/v1/token",
          {
            username: this.username,
            password: this.password,
          }
        );
        if (response.data.token) {
          this.$emit("authState", "loggedIn", response.data.token);
        }
      } catch (e) {
        this.error = "incorrect email or password";
      }
    },
  },
};
</script>